import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { Category } from "@types";
import { App } from "antd";

export const useEditCategory = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { message } = App.useApp();

  const editCategory = async (category: Category) => {
    try {
      const response = await axios.put(
        `/api/categories/${category.id}`,
        category
      );
      return response.data;
    } catch (error) {
      throw new Error(t("messages.error.editCategory"));
    }
  };

  return useMutation({
    mutationFn: editCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      queryClient.invalidateQueries({ queryKey: ["questions"] });
      message.success(t("messages.success.editCategory"));
    },
  });
};
